import Card from "components/Card/Card";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import moment from "moment";
import NotificationSystem from "react-notification-system";

import {
  Button,
  Grid,
  Table,
  OverlayTrigger,
  Tooltip,
  Pagination,
  Modal,
  Alert,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  Row,
} from "react-bootstrap";
import LoadingSpinner from "views/Components/loadingSpinner";
import { GetAllUserForDoctorEarnings } from "Listfunction";
import { getDoctorEarningHistoryById } from "Listfunction";
import { getTotalDoctorEarningById } from "Listfunction";
import { redeemDoctorEarning } from "Listfunction";
import NoDataImage from "../../../assets/img/noOrder.svg";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const DoctorEarningRedeemView = (props) => {
  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const _notificationSystem = React.createRef();
  const [noRecordFound, setnoRecordFound] = useState(false);
  const [loading, setLoading] = useState(false);
  const [doctorList, setDoctorList] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [doctorEarningsHistoryModal, setDoctorEarningsHistoryModal] =
    useState(false);
  const [doctorId, setDoctorId] = useState();
  const [doctorEarningHistory, setDoctorEarningHistory] = useState();
  const [totalDoctorEarnings, setTotalDoctorEarnings] = useState();
  const [redeemDoctorEarningsModal, setRedeemDoctorEarningsModal] =
    useState(false);
  const [redeemAmount, setRedeemAmount] = useState();
  const [descprition, setDescprition] = useState();
  const [searchParam, setSearchParam] = useState();
  const [redeemAmountError, setRedeemAmountError] = useState(null);
  const [doctorName, setDoctorName] = useState("");
  const [redeemAmountNegativeError, setRedeemAmountNegativeError] =
    useState(false);

  useEffect(() => {
    setLoading(true);
    GetAllUserForDoctorEarnings(obj, currentPage, "")
      .then((res) => {
        setCurrentPage(res.data.first_page_url);
        setTotalPage(res.data.last_page);
        const users = res.data.data;
        setDoctorList(users);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const showDoctorEarningsHistoryModal = (id, name) => {
    setDoctorEarningsHistoryModal(true);
    setRedeemAmountNegativeError(false);
    setRedeemAmountError(null);
    setRedeemAmount(undefined);
    setDoctorId(id);
    setDoctorName(name);

    getDoctorEarningHistoryById(obj, id).then((res) => {
      const SelectedDate = res.data.reduce((acc, transaction) => {
        const date = transaction.created_at.split(" ")[0];
        if (!acc[date]) {
          acc[date] = [];
        }

        acc[date].push(transaction);
        return acc;
      }, {});

      // const groupedData = SelectedDate(res.data);

      setDoctorEarningHistory(SelectedDate);
      console.log("groupedData", SelectedDate);
    });

    getTotalDoctorEarningById(obj, id).then((res) => {
      setTotalDoctorEarnings(res.data);
    });
  };

  const showDoctorEarningsRedeemModal = (id, name) => {
    setDoctorName(name);
    setRedeemDoctorEarningsModal(true);
    setRedeemAmount(undefined);
    setRedeemAmountError(null);
    setDoctorId(id);
  };

  const navigateRedeemDoctorEarnings = () => {
    setDoctorEarningsHistoryModal(false);
    setRedeemDoctorEarningsModal(true);
    setRedeemAmount(undefined);
    setRedeemAmountError(null);
    setRedeemAmountNegativeError(false);
  };

  const handleRedeemOnchange = (e) => {
    const { value } = e.target;

    const rejaxValidation = /^[+]?[0-9]*\.?[0-9]+$/;
    if (e.target.name == "redeem_amount") {
      if (rejaxValidation.test(value) === true && value != 0) {
        setRedeemAmount(value);
        setRedeemAmountError(null);
        setRedeemAmountNegativeError(false);
      } else if (value === "") {
        setRedeemAmount(undefined);
      } else {
        setRedeemAmount(null);
        setRedeemAmountNegativeError(true);
        // setRedeemAmountError(
        //   <small className="text-danger">
        //     Redeem Amount must be positive number.
        //   </small>
        // );
      }
    }
  };

  const handleSubmit = async () => {
    if (redeemAmount === undefined) {
      setRedeemAmountError(
        <div class="alert alert-danger" role="alert">
          Redeem Amount Required
        </div>
      );
    } else if (redeemAmountNegativeError) {
      setRedeemAmountError(
        <div class="alert alert-danger" role="alert">
          Redeem amount must be positive number
        </div>
      );
    } else {
      setRedeemAmountError(null);
      const doctorEarningsRedeemBody = {
        doctor_id: doctorId,
        redeem_type: "cash to cash",
        amount: Number(redeemAmount),
      };
      const notification = _notificationSystem.current;
      const res = await redeemDoctorEarning(doctorEarningsRedeemBody, obj);
      if (res.success === true) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>Earnings</b> - Redeemed Successfully .
            </div>
          ),
          level: "success",
          position: "bl",
          autoDismiss: 15,
        });
        setRedeemDoctorEarningsModal(false);
        setRedeemAmount(undefined);
        setDescprition(null);
      } else {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>{res.data}</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    }
  };
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchParam(value);

    setLoading(true);
    GetAllUserForDoctorEarnings(obj, currentPage, value)
      .then((res) => {
        setCurrentPage(res.data.first_page_url);
        setTotalPage(res.data.last_page);
        const users = res.data.data;
        setDoctorList(users);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleReset = (e) => {
    setSearchParam("");
    setLoading(true);
    GetAllUserForDoctorEarnings(obj, currentPage, "")
      .then((res) => {
        setCurrentPage(res.data.first_page_url);
        setTotalPage(res.data.last_page);
        const users = res.data.data;
        setDoctorList(users);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDirectDoctorPayouts = (e) => {
    props.history.push("/admin/doctor-payouts");
  };

  let active = currentPage;
  let items = [];
  for (let number = 1; number <= totalPage; number++) {
    items.push(
      <Pagination.Item
        onClick={() => GetAllUserForDoctorEarnings(obj, number)}
        active={number === active}
      >
        {number}
      </Pagination.Item>
    );
  }

  const earningHistory = (
    <Tooltip id="earningHistory">View Earning History</Tooltip>
  );
  const addDebitLog = <Tooltip id="addDebit">Add Debit Log</Tooltip>;

  return (
    <Grid fluid>
      <Col xs={12} sm={12} md={12} lg={12}>
        <NotificationSystem ref={_notificationSystem} />
        <Row>
          <Col xs={4} sm={4} md={4} lg={4} className="text-left">
            <FormControl
              style={{ position: "relative", marginTop: "25px" }}
              name="search"
              value={searchParam}
              placeholder="Search"
              onChange={(event) => handleSearch(event)}
              type="text"
              className="text-input"
            />
          </Col>
          <Col xs={2} sm={2} md={2} lg={2} className="text-left">
            <Button
              style={{ marginTop: "25px" }}
              className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
              onClick={() => handleReset()}
            >
              Reset
            </Button>
          </Col>
          <div
            xs={2}
            sm={2}
            md={2}
            lg={2}
            className="text-left"
            style={{
              justifyContent: "flex-end",
              display: "flex",
              marginRight: "15px",
            }}
          >
            <Button
              style={{ marginTop: "25px" }}
              className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
              onClick={() => handleDirectDoctorPayouts()}
            >
              Doctor Payout
            </Button>
          </div>
        </Row>
      </Col>
      <br />
      <Col md={12}>
        <Card
          content={
            <>
              <React.Fragment>
                <Table cla responsive>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Doctor</th>
                      <th style={{ textAlign: "end" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td>
                          <LoadingSpinner />
                        </td>
                      </tr>
                    ) : noRecordFound ? (
                      <tr>
                        <td colspan="10">
                          <center>No record found</center>
                        </td>
                      </tr>
                    ) : (
                      <React.Fragment>
                        {doctorList &&
                          doctorList.map((item, i) => (
                            <>
                              <tr>
                                <td>{item.id}</td>
                                <td>{item.name}</td>
                                <td style={{ textAlign: "end" }}>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={earningHistory}
                                  >
                                    <Button
                                      simple
                                      bsStyle="info"
                                      bsSize="xs"
                                      style={{ border: "none" }}
                                      onClick={() => {
                                        showDoctorEarningsHistoryModal(
                                          item.id,
                                          item.name
                                        );
                                      }}
                                    >
                                      <i class="fa fa-history" />
                                    </Button>
                                  </OverlayTrigger>
                                  &nbsp;
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={addDebitLog}
                                  >
                                    <Button
                                      simple
                                      bsStyle="info"
                                      bsSize="xs"
                                      style={{ border: "none" }}
                                      onClick={() =>
                                        showDoctorEarningsRedeemModal(
                                          item.id,
                                          item.name
                                        )
                                      }
                                    >
                                      <i class="fa fa-plus" />
                                    </Button>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            </>
                          ))}
                      </React.Fragment>
                    )}
                  </tbody>
                </Table>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Pagination bsSize="medium">{items}</Pagination>
                </div>
              </React.Fragment>
            </>
          }
        />
      </Col>
      <Modal
        show={doctorEarningsHistoryModal}
        onHide={() => {
          setDoctorEarningsHistoryModal(false);
          setDoctorEarningHistory();
          setTotalDoctorEarnings();
        }}
        allowFullScreen
        bsSize="large"
        className="doctorEarningModal"
      >
        <Modal.Header>
          <Modal.Title
            style={{ textTransform: "capitalize" }}
          >{`${doctorName}'s Earnings History`}</Modal.Title>
        </Modal.Header>
        <Row>
          <Col
            sm={12}
            md={12}
            xs={12}
            className="text-right"
            // style={{ backgroundColor: "rgba(245,245,245,255)" }}
          >
            {totalDoctorEarnings && totalDoctorEarnings.cash_total !== 0 && (
              <Button
                onClick={() => navigateRedeemDoctorEarnings()}
                style={{
                  marginTop: "10px",
                  marginRight: "20px",
                  backgroundColor: "rgba(245,245,245,255)",
                }}
                fill
              >
                Add Debit Log <i className="fa fa-plus"></i>
              </Button>
            )}
          </Col>
        </Row>
        <Col
          sm={12}
          md={12}
          xs={12}
          lg={12}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "rgba(245,245,245,255)",
          }}
        >
          <h5>{"TOTAL EARNINGS" || <Skeleton />}</h5>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              marginTop: "-24px",
            }}
          >
            {(
              <img
                width={50}
                height={50}
                // style={{ alignItems: "center" }}
                src="https://flash.health/wp-content/plugins/flash-frontend/public/images/ph_wallet-light.svg"
              />
            ) || <Skeleton />}
            &nbsp;
            <h3 style={{ marginBottom: "18px" }}>
              {(totalDoctorEarnings &&
                `LKR ${totalDoctorEarnings.cash_total.toFixed(2)}`) || (
                <Skeleton />
              )}
            </h3>
          </div>
        </Col>
        <br />
        <br />
        <Modal.Body
          style={{
            overflowY: "scroll",
            height: "60vh",
            backgroundColor: "rgba(245,245,245,255)",
          }}
        >
          {doctorEarningHistory &&
          Object.keys(doctorEarningHistory).length === 0 ? (
            <>
              <Col
                sm={12}
                md={12}
                xs={12}
                lg={12}
                style={{ textAlign: "center" }}
              >
                <img
                  width="300"
                  height="300"
                  style={{
                    alignItems: "center",
                    alignSelf: "center",
                    textAlign: "center",
                  }}
                  src={NoDataImage}
                />
                <h2 style={{ textAlign: "center" }}>No Earnings</h2>
              </Col>
            </>
          ) : (
            doctorEarningHistory &&
            Object.keys(doctorEarningHistory).map((history) => (
              <div key={history}>
                <Col md={12} sm={12} xs={12} lg={12}>
                  <h5
                    style={{
                      fontSize: "16",
                      fontWeight: "bold",
                      paddingLeft: "20px",
                      // color: "#8e9293",
                    }}
                  >
                    {moment(history).format("MMM-DD")}
                  </h5>
                </Col>
                <Row
                  style={{
                    padding: "40px",
                    textAlign: "center",
                    alignItems: "center",
                  }}
                >
                  {doctorEarningHistory[history].map(
                    (trans, index) =>
                      (
                        <React.Fragment key={index}>
                          <Col
                            md={5}
                            sm={5}
                            xs={5}
                            lg={5}
                            key={index}
                            style={{
                              // marginRight: "70px",
                              marginBottom: "10px",
                              borderRadius: "4px",
                              backgroundColor: "#fff",
                              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                              padding: "10px",
                              textAlign: "center",
                              alignItems: "center",
                            }}
                          >
                            <Row
                              style={{
                                alignItems: "center",
                                alignSelf: "center",
                              }}
                            >
                              <Col
                                md={1}
                                sm={1}
                                xs={1}
                                lg={1}
                                style={{
                                  textAlign: "center",
                                  alignItems: "center",
                                }}
                              >
                                {trans.credit !== null ? (
                                  <i
                                    className="fa fa-plus"
                                    style={{
                                      fontSize: "20px",
                                      color: "green",
                                      marginTop: "7px",
                                    }}
                                  ></i>
                                ) : (
                                  <i
                                    className="fa fa-minus"
                                    style={{
                                      fontSize: "20px",
                                      color: "red",
                                      marginTop: "7px",
                                    }}
                                  ></i>
                                )}
                              </Col>
                              <Col
                                md={7}
                                sm={7}
                                xs={7}
                                lg={7}
                                style={{
                                  textAlign: "left",
                                  alignItems: "center",
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    marginBottom: "-2px",
                                  }}
                                >
                                  {trans.earning_type}
                                </p>
                                <p
                                  style={{
                                    fontSize: "13px",
                                    fontWeight: "bold",
                                    color: "#8e9293",
                                    // marginBottom: "10px",
                                  }}
                                >
                                  {`${
                                    trans.credit
                                      ? `Earnings for consult #${trans.order_id}`
                                      : "Payout for consultations"
                                  }`}
                                </p>
                              </Col>
                              <Col
                                md={4}
                                sm={4}
                                xs={4}
                                lg={4}
                                style={{
                                  marginLeft: "-10px",
                                  textAlign: "center",
                                }}
                                className="text-right"
                              >
                                <p
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    marginTop: "7px",
                                    color: trans.credit ? "green" : "red",
                                  }}
                                >
                                  {`LKR ${
                                    trans.credit !== null
                                      ? trans.credit
                                      : trans.debit
                                  }`}
                                </p>
                              </Col>
                            </Row>
                          </Col>
                          {index % 2 == 0 && (
                            <Col sm={2} md={2} xs={2} lg={2}>
                              &nbsp;
                            </Col>
                          )}
                        </React.Fragment>
                      ) || <Skeleton />
                  )}
                </Row>
              </div>
            ))
          )}
        </Modal.Body>
        <Modal.Footer>
          <Col sm={12} md={12} xs={12} className="text-right">
            <Button
              bsStyle="danger"
              fill
              onClick={() => {
                setDoctorEarningsHistoryModal(false);
                setDoctorEarningHistory();
                setTotalDoctorEarnings();
              }}
            >
              Cancel
            </Button>
          </Col>
        </Modal.Footer>
      </Modal>

      <Modal
        show={redeemDoctorEarningsModal}
        onHide={() => setRedeemDoctorEarningsModal(false)}
        bsSize="large"
        allowFullScreen
      >
        <Modal.Header>
          <Modal.Title style={{ textTransform: "capitalize" }}>
            {`${doctorName}'s Redeem Earnings`}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={7} md={7} xs={7}>
              <ControlLabel>Redeem Amount</ControlLabel>
              <FormGroup>
                <FormControl
                  type="number"
                  name="redeem_amount"
                  min={1}
                  value={redeemAmount}
                  placeholder="Enter the redeem amount "
                  onChange={(e) => handleRedeemOnchange(e)}
                />
              </FormGroup>
              {redeemAmountError}
            </Col>
            <Col sm={7} md={7} xs={7}>
              <ControlLabel>Description</ControlLabel>
              <textarea
                className="form-control"
                rows="4"
                cols="5"
                name="description"
                onChange={(e) => setDescprition(e.target.value)}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="success" fill onClick={() => handleSubmit()}>
            Submit
          </Button>
          <Button
            bsStyle="danger"
            fill
            onClick={() => setRedeemDoctorEarningsModal(false)}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </Grid>
  );
};

export default DoctorEarningRedeemView;
